import {makeAutoObservable} from "mobx";

class OrderPayStore {
    id = 0;
    sn = '';
    price = 0;
    status = undefined;
    createTime = 0;
    delivery = undefined;
    orderAddress = undefined;
    orderProductList = [];
    payType = undefined;
    payTypeList = [];
    currentPayTypeId = 0;
    showBackModel = false;

    constructor() {
        makeAutoObservable(this)
    }
}

export default new OrderPayStore();